<template>
    <div>
        <h3>Cloud Configuration</h3>
        <div class="row">
            <div class="col">
                <div class="sau-bx bx-pad">
                    <div class="row">
                        <div class="col-lg-12" v-if="!gotData">
                           <div class="row">
                                <!-- Fetching Data -->
                                <div class="col">
                                    <div class="text-center">
                                        <img src="/img/spinner.gif" />
                                        <h6 class="sau-pm-reset">
                                            Fetching Configuration
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div class="col-sm-12 col-md-6" v-if="gotData">
                            <ul class="sau-list-display">
                                <li v-for="(val, key) in this.col1" :key="key">
                                    <h5>{{ val[0] }}</h5>
                                    <p>{{ val[1] }}</p>
                                </li>
                            </ul>
                        </div>
                        <div class="col-sm-12 col-md-6" v-if="gotData">
                            <ul class="sau-list-display">
                                <li v-for="(val, key) in this.col2" :key="key">
                                    <h5>{{ val[0] }}</h5>
                                    <p>{{ val[1] }}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <licensing></licensing>
    </div>
</template>

<script>
import Licensing from '../Licensing';
export default {
    components: {
        'licensing': Licensing,
    },
    props: ['service'],
    data() {
        return {
            filtered: [],
            formatted: [],
            col1: [],
            col2: []
        }
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            this.getDeviceStatus().then(response => {
                if(response.data) {
                    // Add to this.service.custom
                    this.service.custom["CPU"] = response.data.cpus;
                    this.service.custom['Disk Space'] = this.formatBytes(response.data.diskSpace / 1000);
                    this.service.custom['Memory'] = this.formatBytes(response.data.memory);
                    this.service.custom['Operating System'] = response.data.osName;
                    this.service.custom['Dedicated IP'] = this.service.ipaddress;
                    this.formatDetails();
                }
            }).catch(error => {})
        },
        formatDetails() {
            let x = 1;
            _.forIn(this.service.custom, function(val, key) {
                if(x % 2) {
                    this.col1.push([key, val]);
                } else {
                    this.col2.push([key, val]);
                }
                x++;
            }.bind(this));
            this.formatted = _.chunk(this.filtered, Math.ceil(this.filtered.length / 2));
        },
        formatBytes(amount) {

            if(amount / 1000000000 > 1) {
                return Math.round(amount / 1000000000) + ' TB';
            }
            if(amount / 1000000 > 1) {
                return Math.round(amount / 1000000) + ' GB';
            }
            if(amount / 1000 > 1) {
                return Math.round(amount / 1000) + ' MB';
            }
            return amount + ' B';
        }
    },
}
</script>

<style>
</style>
